import { useEffect, useState } from 'react';

export function useGracePeriodOverdue(
  timestampMs: number | null | undefined,
  delayMs: number,
): boolean {
  const [overdue, setOverdue] = useState(
    () => timestampMs !== undefined && timestampMs !== null && Date.now() >= timestampMs + delayMs,
  );

  useEffect(() => {
    if (timestampMs === undefined || timestampMs === null) {
      setOverdue(false);
      return;
    }

    const remaining = timestampMs + delayMs - Date.now();
    if (remaining <= 0) {
      setOverdue(true);
      return;
    }

    setOverdue(false);
    const timeout = setTimeout(() => setOverdue(true), remaining);
    return () => clearTimeout(timeout);
  }, [timestampMs, delayMs]);

  return overdue;
}
